import { Injectable, TemplateRef } from '@angular/core';

export interface Toast {
    template: TemplateRef<any> | string;
  classname?: string;
  delay?: number;
  error?: string;
  message?: string;
  header?: string;
  type?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	toasts: Toast[] = [];
    templates: { [key: string]: TemplateRef<any> } = {};

    addTemplate(name: string, template: TemplateRef<any>) {
        this.templates[name] = template;
      }

	show(toast: Toast) {
		this.toasts.push(toast);
	}

	remove(toast: Toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}